import React, {useState} from 'react';
import { Link } from "react-router-dom";



const Home = () => { 
  const [showBanner, setShowBanner] = useState(true);

  const closeBanner = () => {
    setShowBanner(false);
  };
  return (
    
   /* <div className="container home-container">
      {/* Hero Section with high-resolution image */
      /*<section className="hero-section">
        <img 
          src="/images/download.jpg" 
          alt="Luxury Background" 
          className="hero-image"
        />
      </section>


      {/* About Us Section */
      /*<section className="about-section">
        <h2>About Us</h2>
        <p>
          We are a luxury brand offering exclusive collections that reflect elegance and sophistication.
          Our story is one of passion, craftsmanship, and attention to detail. We strive to provide our clients with the finest experiences.
        </p>
        <button className="read-more-btn">Read More</button>
      </section>

      {/* Collection Section */
     /* <section className="collection-section">
        <h2>Our Collection</h2>
        <p>
          Explore our exclusive collection that blends timeless elegance with modern trends. Each piece is crafted to perfection, ensuring an unforgettable experience.
        </p>
        <button className="explore-more-btn">Explore More</button>
      </section>

      {/* Footer Section */
      /*<footer className="footer">
        <p>&copy; 2025 Your Brand. All Rights Reserved.</p>
      </footer>
    </div>
  );
}; */


  <div className="home-container">
    {/* Hero Section with high-resolution image (Now outside of the container) */}
    <section className="hero-section">
      <img 
        src="/images/almost.jpg" 
        alt="Luxury Background" 
        className="hero-image"
      />
      <div className="hero-overlay">
        <h1>Cushions By Asma</h1>
        <p>Apportez confort et charme à votre intérieur avec nos coussins uniques.</p>
        <Link to="/collection" class="hero-btn">Découvrir</Link>
      </div>
    </section>

    <div className="container">
      {/* About Us Section */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-images">

            <img src="/images/luxury.jpg" alt="Coussin élégant"  class="cushion cushion-1"/>
            <img src="/images/fourth.jpg" alt="Coussin décoratif" class="cushion cushion-2"/>

          </div>
          <div className="about-text">


          <h2>Notre histoire et notre passion pour l'élégance du coussin</h2>
          <p>

          Bienvenue dans notre univers, où le luxe rencontre l’élégance !

          Chez Cushions By Asma, nous sommes spécialisés dans la création de coussins décoratifs haut de gamme, conçus pour apporter une touche unique et raffinée à votre intérieur. Chaque pièce est soigneusement pensée et fabriquée avec passion, alliant des matériaux de qualité supérieure à un design intemporel.

          Fondé par une passionnée de décoration, notre atelier reflète un amour profond pour les détails, les textures et l'art de sublimer les espaces. Nous croyons que chaque coussin raconte une histoire, qu’il s’agisse d’ajouter une pointe de sophistication à votre salon ou de créer une ambiance chaleureuse et accueillante.

          Nous nous engageons à offrir des créations qui incarnent le style, le confort et l'exclusivité. Rejoignez-nous pour transformer votre maison en un véritable havre de beauté et de luxe.

          Merci de partager notre passion pour l’élégance et le design !
         </p>
         <Link to="/about" className="read-more-btn">Savoir plus</Link>
         </div>
        </div>
      </section>

      {/* Collection Section */}
      <section className="collection-section">
        <div className="collection-header">
        <h2>Notre Collection</h2>
        <p>
        Découvrez notre collection exclusive qui allie élégance intemporelle et tendances modernes. Chaque pièce est conçue avec soin pour vous offrir une expérience inoubliable.
        </p>
        </div>
        <div className="collection-grid">
          <div className="collection-item">
            <img src="/images/coll11.jpg" alt="Luxury Cushion 1" />
            <h3>Élégance Raffinée</h3>
          </div>
          <div className="collection-item">
            <img src="/images/coll22.jpg" alt="Luxury Cushion 2" />
            <h3>Charme Moderne</h3>
          </div>
          <div className="collection-item">
            <img src="/images/coll33.jpg" alt="Luxury Cushion 3" />
            <h3>Classique Intemporel</h3>
          </div>
          <div className="collection-item">
            <img src="/images/coll44.jpg" alt="Luxury Cushion 4" />
            <h3>Élégance Audacieuse</h3>
          </div>

        </div>
        
        <Link to="/collection" className="explore-more-btn">Découvrir plus</Link>
      </section>

      {/* Footer Section */}
      <footer />
      {showBanner && (
        <div className="order-banner">
          <p>
            📸 Commandez en toute simplicité! Prenez une capture d’écran du modèle choisi et envoyez-la sur{" "}
            <a href="https://wa.me/NUMERO" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>{" "}
            📲.
          </p>
          <span className="close-banner" onClick={closeBanner}>✖</span>
        </div>
      )}
    </div>
  </div>
);
};




export default Home;

